<template>
  <div>
    <label :for="id">
      <form-field
        full-width
        :required="required"
        type="textarea"
        :label="label"
        :id="`input_${_uid}`"
        :name="`input_${_uid}`"
        :helper-text="helper_text"
        :show-counter="maxlengthVal !== null"
        :max-length="maxlengthVal"
        v-model="localVal"
        :placeholder="placeholder"
        @input="handleKeyUp"
      ></form-field>
    </label>

    <p v-if="error" class="validation-error">{{error}}</p>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String
    },
    placeholder: {
      type: String,
      default: "Enter a value here"
    },
    required: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Object]
    },
    error: {
      type: [String, Object]
    },
    helper_text: {
      type: String
    },
    type: {
      type: String,
      default: "text"
    },
    minlength: {
      type: String,
      default: "0"
    },
    maxlength: {
      type: String,
      default: false
    }
  },
  methods: {
    handleKeyUp(e) {
      const value = e.target ? e.target.value : e;
      this.$emit('input',value);
      //   console.log(e.target.value);
    }
  },
  computed: {
    compVal: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit("input", newVal);
        return newVal
      }
    },
    maxlengthVal() {
      if (this.maxlength) {
        return parseInt(this.maxlength);
      }
      return false
    }
  },
  data() {
    return {
      id: null,
      localVal: null
    };
  },
  mounted() {
    this.id = this._uid;
    this.localVal = this.value;
  }
};
</script>

<style scoped lang='scss'>
label {
  font-size: 1.25rem;
  line-height: 1.2;
  padding-bottom: 0.5rem;
  display: inline-block;
  width: 100%;
}

.reqstar {
  color: red;
}

textarea {
  border: 2px solid #c9ced4;
  border-radius: 4px;
  background: #ffffff;
  font-size: 16px;
  padding: 1em;
  display: block;
  width: auto;
  padding-right: 3em;
  max-width: 100%;
  width: 100%;
  @media (min-width: 768px) {
    width: 400px;
    height: 100px;
    max-width: 33vw;
  }
}
</style>